export const getFieldDataQueryVariables = ({
  curriculumProgramId,
  curriculumNodeInterfaceType,
  fieldKey,
}) => {
  return {
    id: curriculumProgramId,
    type: curriculumNodeInterfaceType,
    templateFilters: {
      curriculumProgramId,
    },
    templateFieldFilters: {
      fieldUids: [fieldKey],
    },
    templateFieldPlannerElementSetFilters: {
      curriculumProgramId,
    },
  };
};
